function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useRef } from "react";
import classnames from "classnames";
import { animated } from "@react-spring/web";
import { usePropsValue } from "../../utils/use-props-value";
import { traverseReactNode } from "../../utils/traverse-react-node";
import { withNativeProps } from "../../utils/with-native-props";
import ScrollMask from "../scroll-mask";
import { useTabListScroll } from "../../utils/use-tab-list-scroll";
import { ShouldRender } from "../../utils/should-render";
import { useResizeEffect } from "../../utils/use-resize-effect";
import { Pane } from "./panes";
import { attachPropertiesToComponent } from "../../utils/attach-properties-to-component";
import Grid from "../grid";
var classPrefix = "tc-selector";
export var SelectorTab = function SelectorTab() {
  return null;
};
var Selector = function Selector(props) {
  var children = props.children,
    defaultActiveKey = props.defaultActiveKey,
    _props$canScroll = props.canScroll,
    canScroll = _props$canScroll === void 0 ? false : _props$canScroll,
    _onChange = props.onChange,
    columns = props.columns,
    gap = props.gap,
    type = props.type,
    theme = props.theme,
    style = props.style;
  var tabListContainerRef = useRef(null);
  var rootRef = useRef(null);
  var keyToIndexRecord = {};
  var firstActiveKey = null;
  var panes = [];
  traverseReactNode(children, function (child, index) {
    if (! /*#__PURE__*/React.isValidElement(child)) return;
    var key = child.key;
    if (typeof key !== "string") return;
    if (index === 0) {
      firstActiveKey = key;
    }
    var length = panes.push(child);
    keyToIndexRecord[key] = length - 1;
  });
  var _usePropsValue = usePropsValue({
      value: props.activeKey,
      defaultValue: defaultActiveKey !== null && defaultActiveKey !== void 0 ? defaultActiveKey : firstActiveKey,
      onChange: function onChange(v) {
        if (!v) return;
        _onChange === null || _onChange === void 0 ? void 0 : _onChange(v);
      }
    }),
    _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
    activeKey = _usePropsValue2[0],
    setActiveKey = _usePropsValue2[1];
  var _useTabListScroll = useTabListScroll(tabListContainerRef, keyToIndexRecord[activeKey]),
    scrollLeft = _useTabListScroll.scrollLeft,
    animate = _useTabListScroll.animate;
  useResizeEffect(function () {
    animate(true);
  }, rootRef);
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix,
    ref: rootRef,
    style: style
  }, canScroll ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-header")
  }, /*#__PURE__*/React.createElement(ScrollMask, {
    scrollTrackRef: tabListContainerRef
  }), /*#__PURE__*/React.createElement(animated.div, {
    className: "".concat(classPrefix, "-tab-list"),
    ref: tabListContainerRef,
    scrollLeft: scrollLeft
  }, /*#__PURE__*/React.createElement(Pane, {
    panes: panes,
    selectorProps: props,
    activeKey: activeKey,
    setActiveKey: setActiveKey
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-container")
  }, panes.map(function (pane) {
    if (pane.props.children === undefined) {
      return null;
    }
    var active = pane.key === activeKey;
    return /*#__PURE__*/React.createElement(ShouldRender, {
      key: pane.key,
      active: active,
      forceRender: pane.props.forceRender,
      destroyOnClose: pane.props.destroyOnClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-content"),
      style: {
        display: active ? "block" : "none"
      }
    }, pane.props.children));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-list")
  }, /*#__PURE__*/React.createElement(Grid, {
    columns: columns || 2,
    gap: gap
  }, panes.map(function (pane) {
    var _classnames;
    return withNativeProps(pane.props, /*#__PURE__*/React.createElement(Grid.Item, {
      className: "".concat(classPrefix, "-list-wrapper"),
      span: pane.props.span,
      key: pane.key
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        var key = pane.key;
        if (pane.props.disabled) return;
        if (key === undefined || key === null) {
          return;
        }
        setActiveKey(key.toString());
      },
      className: classnames("".concat(classPrefix, "-tab"), "".concat(classPrefix, "-tab-").concat(type), "".concat(classPrefix, "-tab-").concat(theme), (_classnames = {}, _defineProperty(_classnames, "".concat(classPrefix, "-tab-active"), pane.key === activeKey), _defineProperty(_classnames, "".concat(classPrefix, "-tab-disabled"), pane.props.disabled), _defineProperty(_classnames, "".concat(classPrefix, "-tab-desc"), pane.props.desc), _classnames))
    }, /*#__PURE__*/React.createElement("span", null, pane.props.title), /*#__PURE__*/React.createElement("span", null, pane.props.desc))));
  })))));
};
Selector.defaultProps = {
  theme: "solid",
  type: "square",
  canScroll: false
};
export default attachPropertiesToComponent(Selector, {
  Item: SelectorTab
});